// Library
import { defineStyleConfig } from '@chakra-ui/react';

export const Heading = defineStyleConfig({
  baseStyle: {
    fontFamily: '"Jost", sans-serif',
    fontWeight: 'medium',
    lineHeight: 'normal',
  },
  variants: {
    h1: {
      fontSize: 'hm',
      color: 'text.base',
      fontWeight: 'semibold',
    },
    h2: {
      fontSize: 'hs',
      color: 'text.base',
      fontWeight: 'medium',
    },
  },
});
